import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const salesSummaryApiSlice = createApi({
  reducerPath: 'salesSummaryApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    /**
     * The report is scoped to the selected restaurant by request *headers*, so
     * `companyId` is not sent — it only keeps the cache key per-restaurant.
     * Without it, switching restaurant would replay the previous one's rows.
     */
    getSalesSummary: builder.query({
      query: ({ apiManager, companyId, ...params }) => apiManager.getSalesSummary(params),
    }),
  }),
  serializeQueryArgs,
});

export const { useGetSalesSummaryQuery } = salesSummaryApiSlice;
